import React, { useState } from 'react'
import {
  Box
  // IconButton
} from '@mui/material'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import StyledTabs from 'components/atoms/container/StyledTabs'
import { IconContainer } from 'components/atoms/Icons'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined'
// import { OutlinedInputField } from 'components/atoms/input/StyledInputs'
import InCardStack from 'components/atoms/container/InCardStack'
// import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
// import ArrowCircleUpRoundedIcon from '@mui/icons-material/ArrowCircleUpRounded'
import {
  RenderSummary,
  RenderNotes,
  RenderInsights
} from 'components/molecules/myTeam/meeting/SummaryTabs'
import {
  TabContainer,
  InsightsFloatingBar,
  TranscriptMenu,
  ErrorNotification
} from 'components/molecules/myTeam/meeting/SummaryMolecules'
import { getPopupConfig, setPopupConfig } from 'utils/localStorage'
import PastMeetingSummary from './PastMeetingSummary'
import { SUMMARY_TABS_ID } from 'utils/constants'
import { useTranslation } from 'react-i18next'

const MeetingSummary = ({ event, connection }) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState('SUMMARY')
  const popupTypeSeeInsights = `seeInsightsPopup-${event?.id}`
  const insightsBannerShown = getPopupConfig(popupTypeSeeInsights)

  const TABS = {
    SUMMARY: {
      label: t('fullReport.summary'),
      icon: <IconContainer icon={<ArticleOutlinedIcon />} />,
      color: colors.Grey100,
      secondaryColor: colors.Grey50,
      component: <RenderSummary event={event} />
    },
    NOTES: {
      label: t('common.notes'),
      icon: <IconContainer icon={<StickyNote2OutlinedIcon />} />,
      color: colors.MutedTeal100,
      secondaryColor: colors.MutedTeal50,
      component: <RenderNotes event={event} />
    },
    INSIGHTS: {
      label: t('overview.insights'),
      icon: <IconContainer icon={<TipsAndUpdatesOutlinedIcon />} />,
      color: colors.Purple200,
      secondaryColor: colors.Purple100,
      component: <RenderInsights event={event} />
    }
  }

  const openTab = tab => {
    setActiveTab(tab)
    // Scroll to top of the first child of the container
    if (document.getElementById(SUMMARY_TABS_ID)?.scrollTo)
      document.getElementById(SUMMARY_TABS_ID)?.scrollTo(0, 0)
  }

  const checkBannerDisplay = () => {
    if (activeTab === 'INSIGHTS' || insightsBannerShown) {
      return false
    } else if (activeTab === 'SUMMARY' && event?.summary?.shortSummary) {
      return true
    } else if (activeTab === 'NOTES' && event?.summary?.detailNotes) {
      return true
    }
  }
  const transcriptTooShort = () => {
    const wordCount = Array.isArray(event?.transcript)
      ? event.transcript.reduce((total, segment) => {
          const swCount = Array.isArray(segment.words)
            ? segment.words.reduce((count, word) => {
                return count + (word?.text ? word.text.split(' ').length : 0)
              }, 0)
            : 0
          return total + swCount
        }, 0)
      : 0

    let transcriptTooShort = false
    if (activeTab === 'INSIGHTS') {
      transcriptTooShort = wordCount <= 600
    } else if (activeTab === 'SUMMARY' || activeTab === 'NOTES') {
      transcriptTooShort = wordCount <= 200
    } else {
      transcriptTooShort = false
    }
    return transcriptTooShort
  }

  return (
    <>
      {event?.summary || event?.transcript ? (
        <InCardStack spacing={4} height={'100%'}>
          <RowStack
            spacing={4}
            sx={{
              justifyContent: 'space-between',
              backgroundColor: colors.MetalGrey50,
              borderRadius: 3,
              padding: 4
            }}>
            <StyledTabs
              tabs={Object.keys(TABS).map(key => ({
                ...TABS[key],
                value: key
              }))}
              activeTab={activeTab}
              setActiveTab={openTab}
            />

            <TranscriptMenu event={event} connection={connection} />
          </RowStack>

          {/* TODO: Uncomment when its ready */}
          {/* <OutlinedInputField
            placeholder={t('myTeam.askMonarkAnything')}
            startIcon={
              <AutoAwesomeRoundedIcon sx={{ color: colors.Grey250 }} />
            }
            endIcon={
              <IconButton onClick={() => {}} disabled>
                <ArrowCircleUpRoundedIcon sx={{ color: colors.Grey300 }} />
              </IconButton>
            }
            onChange={e => {}}
            disabled
          /> */}

          <TabContainer
            sx={
              !transcriptTooShort() && {
                backgroundColor: TABS[activeTab].secondaryColor
              }
            }>
            <Box sx={{ paddingBottom: insightsBannerShown ? 0 : 10 }}>
              {transcriptTooShort() ? (
                <ErrorNotification
                  title={t('myTeam.meetingWasTooShort')}
                  description={t('myTeam.meetingWasTooShortErrorMessage')}
                />
              ) : (
                TABS[activeTab].component
              )}
            </Box>

            {checkBannerDisplay() && !transcriptTooShort() && (
              <InsightsFloatingBar
                backgroundColor={TABS[activeTab].color}
                btnAction={() => {
                  openTab('INSIGHTS')
                  setPopupConfig(popupTypeSeeInsights, true)
                }}
              />
            )}
          </TabContainer>
        </InCardStack>
      ) : (
        <TabContainer>
          <PastMeetingSummary event={event} connection={connection} />
        </TabContainer>
      )}
    </>
  )
}

export default MeetingSummary
